import { Box, SxProps, Theme, styled } from "@mui/material";
import { CSSProperties, FC, useEffect, useRef } from "react";

type TInScreenScrollAnchorProps = {
  triggerKey: string;
  enabled?: boolean;
  behavior?: ScrollBehavior;
  block?: ScrollLogicalPosition;
  sx?: SxProps<Theme>;
  style?: CSSProperties;
};

export const InScreenScrollAnchor: FC<TInScreenScrollAnchorProps> = ({
  triggerKey,
  enabled = true,
  behavior = "smooth",
  block = "nearest",
  sx,
  style,
}) => {
  const scrollAnchorRef = useRef<HTMLDivElement>(null);
  const isMountRef = useRef(true);

  useEffect(() => {
    if (isMountRef.current) {
      isMountRef.current = false;
      return;
    }

    if (!enabled) return;

    scrollAnchorRef.current?.scrollIntoView({ behavior, block });
  }, [triggerKey, enabled, behavior, block]);

  return (
    <Box position="relative">
      <DummyScrollAnchor ref={scrollAnchorRef} sx={sx} style={style} />
    </Box>
  );
};

const DummyScrollAnchor = styled("div")({
  position: "absolute",
  left: 0,
  top: 0,
});
